export default __webpack_public_path__ + "static/cover_primaryvision-ea1fc86d582e56378eb78858b8e6ee0d.png";